import { render, staticRenderFns } from "./HostStatus.vue?vue&type=template&id=163bdfed&scoped=true&"
import script from "./HostStatus.vue?vue&type=script&lang=js&"
export * from "./HostStatus.vue?vue&type=script&lang=js&"
import style0 from "./HostStatus.vue?vue&type=style&index=0&id=163bdfed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bdfed",
  null
  
)

export default component.exports